export const IDEAL_CELL_WIDTH = 260;
export const IDEAL_SPACE_BW_TILES = 25;
export const HEADER_FIXED_HEIGHT = 30;
export const OVERSCAN_ROW_COUNT = 6;
export const DEFAULT_CELL_HEIGHT = 250;
export const ESTIMATED_ROW_SIZE = 270;
